
import groupBy from 'lodash/groupBy';
import sortBy from 'lodash/sortBy';

const formatOptions = (content) => {
    const groupedDetails = groupBy(content, detail => detail.category);
    const groupedDetailsTitle = Object.keys(groupedDetails);

    const optionDetails = [];

    groupedDetailsTitle.forEach(group => {
        const sorted = sortBy(groupedDetails[group], 'description');

        optionDetails.push({ category: group, groupdetails: sorted });
    });

    return Array.isArray(optionDetails) ? optionDetails : [];
};

/**
 * @param {String} token
 * @returns {Object}
 */
const getTokenHeader = token => ({ 'x-jwt': token });

const paymentWithTaxDetails = (payment = 0, paymentTaxes = 0, taxesDetail = '', totalPayment = 0) => {
    return `${payment} + ${paymentTaxes} (${taxesDetail}) = ${totalPayment}`;
}

export {
    getTokenHeader,
    formatOptions,
    paymentWithTaxDetails
};
